import { useContext } from 'react'
import { BackHistoryCtx } from './BackHistoryContext.js'

export const useBackHistory = () => useContext(BackHistoryCtx)
